import { useEffect } from 'react';
import { Image } from 'react-konva';
import useImage from 'use-image';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useKonvaImageDimensions } from 'contexts/ToolDimensionsAndScaleContext';
import { konvaImageIds, notifyBaseRasterImageLoaded } from '../utils/konvaUtil';

export default function RasterImage() {

	const { jpgUrl, imgHeight, imgWidth } = useSelector((state: RootState) => state.roofData.data);
	const [image, status] = useImage(jpgUrl, 'anonymous', 'origin');

	useEffect(() => {
		// unblocks anyone awaiting waitForBaseRasterImage() — resolve on failure too so a
		// broken image can't leave a save click waiting forever
		if (status === 'loaded' || status === 'failed') notifyBaseRasterImageLoaded();
	}, [status]);

	return (
		<Image
			image={image}
			id={konvaImageIds.bgImage}
			preventDefault={false}
			height={imgHeight}
			width={imgWidth}
		/>
	);
}